module.exports = __webpack_public_path__ + "img/cambridge_oak_bfusa_list.82c5b210.jpg";